import { render } from "./person-military-create.vue?vue&type=template&id=73aa00f6"
import script from "./person-military-create.vue?vue&type=script&lang=js"
export * from "./person-military-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__